import React from "react";
import { Heart, Bookmark } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { useLists } from "@/contexts/ListsContext";

export default function ListToggleButtons({ item, mediaType, vertical, size = 16 }) {
  const { user } = useAuth();
  const { isIn, toggle } = useLists();

  if (!user) return null;

  const payload = {
    tmdb_id: item.id,
    media_type: mediaType || item.media_type || "movie",
    title: item.title,
    poster: item.poster,
    backdrop: item.backdrop,
    year: item.year,
    rating: item.rating,
    overview: item.overview,
  };

  const click = async (type, e) => {
    e?.stopPropagation();
    e?.preventDefault();
    try {
      const added = await toggle(type, payload);
      toast.success(`${added ? "Added to" : "Removed from"} ${type}`);
    } catch {
      toast.error("Action failed");
    }
  };

  const inFav = isIn("favorites", payload.tmdb_id, payload.media_type);
  const inWatch = isIn("watchlist", payload.tmdb_id, payload.media_type);

  return (
    <div className={`flex ${vertical ? "flex-col" : "flex-row"} gap-1.5`}>
      <button
        onClick={(e) => click("favorites", e)}
        data-testid={`favorite-btn-${payload.tmdb_id}`}
        title={inFav ? "Remove from favorites" : "Add to favorites"}
        className={`p-1.5 rounded-full backdrop-blur-md transition-colors
          ${inFav ? "bg-[var(--tt-primary)] text-white" : "bg-black/60 text-white/80 hover:bg-black hover:text-[var(--tt-primary)]"}`}
      >
        <Heart className={`w-${Math.round(size/4)} h-${Math.round(size/4)} ${inFav ? "fill-current" : ""}`} style={{width: size, height: size}} />
      </button>
      <button
        onClick={(e) => click("watchlist", e)}
        data-testid={`watchlist-btn-${payload.tmdb_id}`}
        title={inWatch ? "Remove from watchlist" : "Add to watchlist"}
        className={`p-1.5 rounded-full backdrop-blur-md transition-colors
          ${inWatch ? "bg-[var(--tt-yellow)] text-black" : "bg-black/60 text-white/80 hover:bg-black hover:text-[var(--tt-yellow)]"}`}
      >
        <Bookmark className={`${inWatch ? "fill-current" : ""}`} style={{width: size, height: size}} />
      </button>
    </div>
  );
}
